/**********
    @name: 主题兼容ant-design
    @describtion:
    @author:liubingye
    @date:2024-03-15 10:05:36
***********/
const el = document.documentElement
import { theme } from 'ant-design-vue'
const { useToken } = theme

// 修改主题色后调用该方法可修改全局主题
export function resetTheme() {
  const token = useToken().token.value
  el.style.setProperty('--ant-design-primary',token.colorPrimary)  //主色
  el.style.setProperty('--ant-design-colorPrimaryActive',token.colorPrimaryActive) //主色梯度下的深色激活态
  el.style.setProperty('--ant-design-primaryBg',token.colorPrimaryBg)      // 主色浅色背景颜色，一般用于视觉层级较弱的选中状态。
  el.style.setProperty('--ant-design-primaryBgHover',token.colorPrimaryBgHover) // 与主色浅色背景颜色相对应的悬浮态颜色。
  el.style.setProperty('--ant-design-primaryHover',token.colorPrimaryHover) //主色梯度下的悬浮态，使用频率很高
  el.style.setProperty('--ant-design-primaryText',token.colorPrimaryText) //主色梯度下的文本颜色


}
